
import { z } from "zod";

export const ConversationItemTypeValues = ["PHONE_CALL", "EMAIL", "MESSAGE", "SMS_MESSAGE"] as const;
export const ConversationItemTypeSchema = /* @__PURE__ */ z.enum(ConversationItemTypeValues);
export const ConversationItemType: (typeof ConversationItemTypeSchema)["enum"] = { "PHONE_CALL": "PHONE_CALL", "EMAIL": "EMAIL", "MESSAGE": "MESSAGE", "SMS_MESSAGE": "SMS_MESSAGE" };
export type ConversationItemType = (typeof ConversationItemTypeValues)[number];
